import { defineStore } from 'pinia';
import { ref } from 'vue';
// 앱 글로벌
export const piniaGlobal = defineStore('global', () => {
    /** 지난 url history */
    const urlHistory = ref('');
    return {
        urlHistory,
    };
});
